import { useState, useCallback } from 'react';
import { useAppDispatch } from '../../../../../../app/store';
import { addWriteoffNoteAction as addWriteoffNote } from '../../../../../../services/WriteoffService/slice';
import { useGetMyProfileQuery } from '../../../../../../services/ProfileService';

export interface UseNoteFormReturn {
  noteText: string;
  setNoteText: (text: string) => void;
  handleSave: () => void;
  handleClose: () => void;
  handleKeyDown: (event: React.KeyboardEvent) => void;
  isValid: boolean;
}

export interface UseNoteFormOptions {
  onClose: () => void;
}

export function useNoteForm({ onClose }: UseNoteFormOptions): UseNoteFormReturn {
  const [noteText, setNoteText] = useState('');
  const dispatch = useAppDispatch();
  const { data: userProfile } = useGetMyProfileQuery();

  const isValid = noteText.trim().length > 0;

  const handleClose = useCallback(() => {
    setNoteText('');
    onClose();
  }, [onClose]);

  const handleSave = useCallback(() => {
    if (noteText.trim()) {
      const newNote = {
        text: noteText.trim(),
        addDate: new Date().toISOString(),
        addedBy: userProfile?.identity || userProfile?.name || 'Unknown User',
      };

      dispatch(addWriteoffNote(newNote));
      setNoteText('');
      onClose();
    }
  }, [noteText, userProfile, dispatch, onClose]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' && event.ctrlKey) {
        handleSave();
      }
    },
    [handleSave]
  );

  return {
    noteText,
    setNoteText,
    handleSave,
    handleClose,
    handleKeyDown,
    isValid,
  };
}
